import { render } from "./TradeStatsTiles.vue?vue&type=template&id=7c4c3a69"
import script from "./TradeStatsTiles.vue?vue&type=script&lang=js"
export * from "./TradeStatsTiles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__